var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCaretRoundedDown = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7706 14.6854L16.6786 10.8337C17.3652 10.157 16.8789 9 15.908 9H8.09203C7.12108 9 6.63483 10.157 7.32139 10.8337L11.2294 14.6854C11.655 15.1049 12.345 15.1049 12.7706 14.6854Z",
    fill: "#202840"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCaretRoundedDown);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/caret-rounded-down.d9920f5e535952ed7ecba6eedcecb5d1.svg";